var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"operative-layout"},[_c('AwlHeader'),_c('router-view',{staticClass:"page"}),_c('ConfirmBox')],1)}
var staticRenderFns = []

export { render, staticRenderFns }